export const CHART_TARGETS = {
  START: 500,
  POINT: 1000,
  END: 1500,
} as const

export const CHART_LABELS = {
  START: '500m',
  POINT: '1km',
  END: '1.5km',
} as const
